<div class="custom-dialog" [@dialogAnim]>
  <!-- Header -->
  <div class="dialog-header">
    <span class="dialog-icon-wrap" *ngIf="data.icon">
      <!-- Success / Check -->
      <mat-icon *ngIf="data.icon === 'success' || data.icon === 'check_small' || data.icon === 'check_circle'"
        color="primary" class="icon-lg">
        check_circle
      </mat-icon>

      <!-- Error -->
      <mat-icon *ngIf="data.icon === 'error'" color="warn" class="icon-lg">
        error
      </mat-icon>

      <!-- Warning -->
      <mat-icon *ngIf="data.icon === 'warning'" color="accent" class="icon-lg text-warning-msg">
        warning
      </mat-icon>

      <!-- Info -->
      <mat-icon *ngIf="data.icon === 'info'" color="primary" class="icon-lg">
        info
      </mat-icon>
    </span>

    <span class="dialog-title">{{ data.title }}</span>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <mat-dialog-content class="dialog-content">
      <div [innerHTML]="data.message | newlineToBreak"></div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-raised-button (click)="closeDialog()">OK</button>
    </mat-dialog-actions>
  </div>
</div>